import React, { useEffect, useState, useMemo,useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { config } from '../utils/config';
import FetchUserDetails from '../services/FetchUserDetails';
import './HomePage.css';
import { capabilities, roles, rubric, headerCards } from '../utils/homeData';
import ProfileModal from './ProfileModal';
import CapabilityCategoryModal from './CapabilityCategoryModal';
import apiService from '../services/api';
import Snackbar from './Snackbar';
import RoleSwitchModal from './RoleSwitchModal';
import DepartmentSwitchModal from './DepartmentSwitchModal';
import BulkUploadResultPopup from './BulkUploadResultPopup';

const version = process.env.REACT_APP_VERSION;

function HomePage() {
  const navigate = useNavigate();
  const [accessRole, setAccessRole] = useState('user');
  const [isLoadingRole, setIsLoadingRole] = useState(true);
  const [userDepartment, setUserDepartment] = useState('');
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const profileDropdownRef = useRef(null);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [categories, setCategories] = useState([]);
const [isCategoryModalOpen, setIsCategoryModalOpen] = useState(false);
const [editingCategory, setEditingCategory] = useState(null);
const [showDeleteConfirm, setShowDeleteConfirm] = useState(null);
const [deleteConfirm, setDeleteConfirm] = useState(null); 
const [isSavingCategory, setIsSavingCategory] = useState(false);
const [snackbar, setSnackbar] = useState({ message: '', type: 'success', isOpen: false });
const [profileImage, setProfileImage] = useState(sessionStorage.getItem("image_url"));
const [isRoleSwitchOpen, setIsRoleSwitchOpen] = useState(false);
const [selectedRoleForManager, setSelectedRoleForManager] = useState(null); 
const [availableRoles, setAvailableRoles] = useState([]); 
const [searchTerm, setSearchTerm] = useState('');
const [availableDepartments, setAvailableDepartments] = useState([]);
const [selectedDepartment, setSelectedDepartment] = useState(null);
const [deptSearchTerm, setDeptSearchTerm] = useState('');
const [selectedRoleForAdmin, setSelectedRoleForAdmin] = useState(null);
const [availableRolesForAdmin, setAvailableRolesForAdmin] = useState([]);
const [roleSearchTerm, setRoleSearchTerm] = useState('');
const [availableRoleFamilies, setAvailableRoleFamilies] = useState([]);
const [selectedRoleFamily, setSelectedRoleFamily] = useState(null);
const [roleFamilySearchTerm, setRoleFamilySearchTerm] = useState('');
const [availableRoleFamiliesForManager, setAvailableRoleFamiliesForManager] = useState([]);
const [selectedRoleFamilyForManager, setSelectedRoleFamilyForManager] = useState(null);
const [roleFamilySearchTermManager, setRoleFamilySearchTermManager] = useState('');
const [roleExpectations, setRoleExpectations] = useState([]);        
const [isLoadingRoles, setIsLoadingRoles] = useState(true);  
const [isLoadingCategories, setIsLoadingCategories] = useState(true);  
const [isDepartmentSwitchOpen, setIsDepartmentSwitchOpen] = useState(false);
const [isGlobalLoading, setIsGlobalLoading] = useState(true);
const [bulkUploadResult, setBulkUploadResult] = useState(null);
const [bulkUploadPopupOpen, setBulkUploadPopupOpen] = useState(false); 
 const dropdownMenuRef = useRef(null);    

useEffect(() => {
  const refreshProfileImage = () => {
    setProfileImage(sessionStorage.getItem("image_url"));
  };

  window.addEventListener("profile-updated", refreshProfileImage);
  return () => window.removeEventListener("profile-updated", refreshProfileImage);
}, []);

useEffect(() => {
  window.availableDepartments = availableDepartments;
}, [availableDepartments]);

const hasMultipleDepartments = () => {
  return accessRole === 'admin' && availableDepartments.length > 1;
};

//   useEffect(() => {
//   const handleClickOutside = (event) => {
//     if (profileDropdownRef.current && !profileDropdownRef.current.contains(event.target)) {
//       setShowProfileDropdown(false);
//     }
//   };
//   document.addEventListener('mousedown', handleClickOutside);
//   return () => document.removeEventListener('mousedown', handleClickOutside);
// }, []);

useEffect(() => {
  const handleOutsideClick = (e) => {
    if (
      profileDropdownRef.current &&
      !profileDropdownRef.current.contains(e.target)
    ) {
      setShowProfileDropdown(false);
    }

    if (!e.target.closest('.dropdown-wrapper')) {
      document
        .querySelectorAll('.dropdown-menu.open')
        .forEach(menu => menu.classList.remove('open'));
    }
  };

  document.addEventListener('mousedown', handleOutsideClick);
  return () =>
    document.removeEventListener('mousedown', handleOutsideClick);
}, []);


useEffect(() => {
  setSelectedRoleForManager(null);
  setSearchTerm('');
}, [sessionStorage.getItem('user_department')]);

useEffect(() => {
  if (selectedRoleForManager && (accessRole === 'manager' || accessRole === 'admin')) {
    fetchCategories();
  }
}, [selectedRoleForManager]);

  
  useEffect(() => {
    document.title = 'CR Capability Index - Home';
    
    const checkAndSetAccessRole = async () => {
      // Get access role from sessionStorage
      let role = sessionStorage.getItem('access_role');
      
      console.log('🔍 Initial access_role from sessionStorage:', role);
      
      // If access_role is not set, fetch user detail
      if (!role || role === 'undefined' || role === 'null') {
        console.log('⚠️ access_role not found, fetching user details...');
        try {
          const success = await FetchUserDetails();
          if (success) {
            role = sessionStorage.getItem('access_role') || 'user';
            console.log('✅ User details fetched, access_role:', role);
          }
        } catch (error) {
          console.error('❌ Error fetching user details:', error);
          role = 'user';
        }
      }
      
      // Normalize role
      const normalizedRole = (role || 'user').toString().toLowerCase().trim();
      
      console.log('🔍 Raw access_role from sessionStorage:', sessionStorage.getItem('access_role'));
      console.log('🔍 Normalized access_role:', normalizedRole);
      console.log('🔍 Role type:', typeof normalizedRole);
      console.log('🔍 Role === "manager":', normalizedRole === 'manager');
      console.log('🔍 Role === "user":', normalizedRole === 'user');
      
      setAccessRole(normalizedRole);
      setIsLoadingRole(false);
      console.log('🎭 User access_role state set to:', normalizedRole);
      
      // Get user department
      const department = sessionStorage.getItem('user_department');
      setUserDepartment(department || '');
      
      // Set global loading false only after all session data is ready
      setTimeout(() => {
        setIsGlobalLoading(false);
      }, 100);
    };
    
    checkAndSetAccessRole();
  }, []);


   useEffect(() => {
  if (!isLoadingRole && accessRole && !isGlobalLoading) {
    if (accessRole === 'admin') {
      fetchAdminDepartments();
    } else {
      fetchCategories();
    }
  }
}, [isLoadingRole, accessRole, isGlobalLoading]);

const fetchAdminDepartments = async () => {
  setIsLoadingCategories(true);
  try {
    const endpoint = '/display-capability-categories?type=admin';
    const response = await apiService.fetchData(endpoint);
    
    if (response?.status === 'success' && response.data) {
      const validDepts = response.data.filter(
        item => item.department_id && item.department_name && item.categories.length > 0
      );

      const deptList = validDepts.map(item => ({
        id: item.department_id,
        name: item.department_name
      }));

      setAvailableDepartments(deptList);

      if (deptList.length > 0 && !selectedDepartment) {
        setSelectedDepartment(deptList[0].name);
      }
    }
  } catch (error) {
    console.error('Failed to fetch admin departments:', error);
  } finally {
    setIsLoadingCategories(false);
  }
};

const fetchRolesForAdmin = async () => {
  if (!selectedDepartment || accessRole !== 'admin') return;
  
  try {
    const dept = availableDepartments.find(d => d.name === selectedDepartment);
    if (!dept) return;
    
    const endpoint = `/metadata?type=roles&department_id=${dept.id}`;
    const response = await apiService.fetchData(endpoint);
    
    if (response?.status === 'success' && Array.isArray(response.data)) {
      setAvailableRolesForAdmin(response.data);
      
      // Extract unique role families from roles
      const roleFamilies = [...new Set(response.data
        .map(role => role.RoleFamilyName)
        .filter(rf => rf && rf !== 'No Role Family')
      )].sort();
      setAvailableRoleFamilies(roleFamilies);
      
      // Reset role family and role selection when department changes
      setSelectedRoleFamily(null);
      setSelectedRoleForAdmin(null);
    } else {
      setAvailableRolesForAdmin([]);
      setAvailableRoleFamilies([]);
      setSelectedRoleFamily(null);
      setSelectedRoleForAdmin(null);
    }
  } catch (error) {
    console.error('Failed to fetch roles for admin:', error);
    setAvailableRolesForAdmin([]);
    setAvailableRoleFamilies([]);
    setSelectedRoleFamily(null);
    setSelectedRoleForAdmin(null);
  }
};

// Get filtered roles based on selected role family
const getFilteredRolesForAdmin = () => {
  if (!selectedRoleFamily) return availableRolesForAdmin;
  return availableRolesForAdmin.filter(role => role.RoleFamilyName === selectedRoleFamily);
};

const fetchManagerRoleCounts = async (rolesWithCategories) => {
  try {
    const departmentId = sessionStorage.getItem('user_department_id');
    if (!departmentId) {
      setAvailableRoles(rolesWithCategories);
      return;
    }
    
    const endpoint = `/metadata?type=roles&department_id=${departmentId}`;
    const response = await apiService.fetchData(endpoint);
    
    if (response?.status === 'success' && Array.isArray(response.data)) {
      const rolesWithCounts = rolesWithCategories.map(role => {
        const roleData = response.data.find(r => r.RoleName === role.roleName);
        return {
          ...role,
          resourceCount: roleData?.resource_count || 0,
          roleFamilyName: roleData?.RoleFamilyName || 'No Role Family'
        };
      });
      setAvailableRoles(rolesWithCounts);
      
      // Extract unique role families for manager
      const roleFamilies = [...new Set(rolesWithCounts
        .map(role => role.roleFamilyName)
        .filter(rf => rf && rf !== 'No Role Family')
      )].sort();
      setAvailableRoleFamiliesForManager(roleFamilies);
    } else {
      setAvailableRoles(rolesWithCategories);
      setAvailableRoleFamiliesForManager([]);
    }
  } catch (error) {
    console.error('Failed to fetch manager role counts:', error);
    setAvailableRoles(rolesWithCategories);
    setAvailableRoleFamiliesForManager([]);
  }
};

// Get filtered roles based on selected role family for manager
const getFilteredRolesForManager = () => {
  if (!selectedRoleFamilyForManager) return availableRoles;
  return availableRoles.filter(role => role.roleFamilyName === selectedRoleFamilyForManager);
};

const fetchCategories = async () => {
  if (isLoadingRole || !accessRole || isGlobalLoading) return;
  setIsLoadingCategories(true);
  let endpoint = '';

  if (accessRole === 'admin') {
    if (!selectedDepartment || !selectedRoleForAdmin) {
      setCategories([]);
      setIsLoadingCategories(false);
      return;
    }
    const department = encodeURIComponent(selectedDepartment);
    const role = encodeURIComponent(selectedRoleForAdmin);
    endpoint = `/display-capability-categories?type=employee&department_name=${department}&role_name=${role}`;
  } else if (accessRole === 'manager') {
    const department = sessionStorage.getItem('user_department') || 'Salesforce';
    endpoint = `/display-capability-categories?type=manager&department_name=${encodeURIComponent(department)}`;
  } else {
    const roleName = sessionStorage.getItem('user_role') || 'Developer';
    const department = sessionStorage.getItem('user_department') || 'Salesforce';
    endpoint = `/display-capability-categories?type=employee&department_name=${encodeURIComponent(department)}&role_name=${encodeURIComponent(roleName)}`;
  }

  console.log('Fetching categories →', { accessRole, endpoint });

  try {
    const response = await apiService.fetchData(endpoint);
    console.log('Raw API Response:', response);

    if (response?.status !== 'success' || !response.data) {
      console.warn('Invalid or empty response');
      setCategories([]);
      setAvailableRoles([]);
      setAvailableDepartments([]);
      return;
    }

    
    const deptId =
      response.department_id ||
      response.data?.department_id ||
      response.data?.[0]?.department_id;

    if (deptId) {
      sessionStorage.setItem("user_department_id", deptId);
    }

    // ========== ADMIN LOGIC ==========
    if (accessRole === 'admin') {
      // Admin viewing specific department + role categories
      if (Array.isArray(response.data)) {
        setCategories(
          response.data
            .filter(cat => cat.IsActive)
            .map(cat => ({
              id: cat.CategoryID,
              name: cat.CategoryName,
              description: cat.Description,
              percentage: cat.Weightage + '%'
            }))
        );
      }
    }

    // ========== MANAGER LOGIC ==========
    else if (accessRole === 'manager') {

      const rolesWithCategories = (response.data || [])
        .filter(item =>
          item.role_name &&
          item.categories &&
          Array.isArray(item.categories)
        )
        .map(item => ({
          roleId: item.role_id,
          roleName: item.role_name,
          categories: item.categories.filter(cat => cat.IsActive)
        }))
        .filter(role => role.categories.length > 0);

      // Fetch resource counts for manager roles
      if (rolesWithCategories.length > 0) {
        fetchManagerRoleCounts(rolesWithCategories);
      } else {
        setAvailableRoles([]);
      }

      if (rolesWithCategories.length === 0) {
        setCategories([]);
        return;
      }

      if (!selectedRoleForManager) {
        setSelectedRoleForManager(rolesWithCategories[0].roleName);
      }

      const roleToShow = selectedRoleForManager || rolesWithCategories[0].roleName;
      const selectedRoleData = rolesWithCategories.find(
        r => r.roleName === roleToShow
      );

      if (selectedRoleData) {
        setCategories(selectedRoleData.categories.map(cat => ({
          id: cat.CategoryID,
          name: cat.CategoryName,
          description: cat.Description,
          percentage: cat.Weightage + '%'
        })));
      }
    }

    // ========== EMPLOYEE LOGIC ==========
    else {

      if (Array.isArray(response.data)) {
        setCategories(
          response.data
            .filter(cat => cat.IsActive)
            .map(cat => ({
              id: cat.CategoryID,
              name: cat.CategoryName,
              description: cat.Description,
              percentage: cat.Weightage + '%'
            }))
        );
      }
    }

  } catch (error) {
    console.error('Failed to fetch categories:', error);
    setCategories([]);
    setAvailableRoles([]);
    setAvailableDepartments([]);
  }
  finally {
    setIsLoadingCategories(false); 
  }
};


useEffect(() => {
  if (accessRole === 'admin' && selectedDepartment) {
    fetchRolesForAdmin();
  }
}, [selectedDepartment]);

useEffect(() => {
  if (accessRole === 'admin' && selectedDepartment && selectedRoleForAdmin) {
    fetchCategories();
  }
}, [selectedRoleForAdmin]);

// Trigger role expectations after categories are fetched (when department_id is set)
useEffect(() => {
  const departmentId = sessionStorage.getItem('user_department_id');
  if (departmentId && !isLoadingCategories && !isGlobalLoading) {
    fetchRoleExpectations();
  }
}, [isLoadingCategories, isGlobalLoading]);

 

// Add this temporarily to see state changes
useEffect(() => {
  console.log('categories state updated:', categories);
}, [categories]);

const fetchRoleExpectations = async () => {
  if (isGlobalLoading) return;
  setIsLoadingRoles(true);

  try {
    // 1️⃣ Get department_id that we stored earlier
    let departmentId = sessionStorage.getItem("user_department_id");

    // 2️⃣ Admin: fallback using selectedDepartment → availableDepartments list
    if (!departmentId && accessRole === "admin" && availableDepartments.length > 0) {
      const dept = availableDepartments.find(
        (d) => d.name === selectedDepartment
      );
      departmentId = dept?.id || null;
    }

    // 3️⃣ If still missing, stop
    if (!departmentId) {
      console.warn("No department_id found for Role Expectations");
      setRoleExpectations([]);
      setIsLoadingRoles(false);
      return;
    }

    // 4️⃣ Build & call API
    const endpoint = `/metadata?type=roles&department_id=${departmentId}`;
    console.log("Fetching role expectations →", endpoint);

    const response = await apiService.fetchData(endpoint);

    // 5️⃣ Store parsed expectations
    if (response?.status === "success" && Array.isArray(response.data) && response.data.length > 0) {
      const formatted = response.data.map((item) => ({
        title: item.RoleName || "Unnamed Role",
        description: item.Description || "No description provided.",
        expectedCI: item.ExpectedCI != null ? `${item.ExpectedCI}` : "Not defined",
        experience: item.ExperienceRange || "Not specified",
      }));

      setRoleExpectations(formatted);
    } else {
      setRoleExpectations([]);
    }
  } catch (err) {
    console.error("Failed to fetch role expectations:", err);
    setRoleExpectations([]);
  } finally {
    setIsLoadingRoles(false);
  }
};



useEffect(() => {
  if (!isLoadingRole && accessRole && !isGlobalLoading) {
    fetchRoleExpectations();
  }
}, [isLoadingRole, accessRole, selectedDepartment, isGlobalLoading]);

// Load role expectations immediately after login when userDepartment is available
useEffect(() => {
  if (userDepartment && !isLoadingRole && !selectedDepartment && !isGlobalLoading) {
    fetchRoleExpectations();
  }
}, [userDepartment, isLoadingRole, isGlobalLoading]);


  // Check if user has multiple roles → show Role Switch option
  const hasMultipleRoles = () => {
    try {
      const rolesList = JSON.parse(sessionStorage.getItem('user_roles') || '[]');
      return Array.isArray(rolesList) && rolesList.length > 1;
    } catch (e) {
      return false;
    }
  };

const handleDownloadTemplate = async () => {
  try {
    // Build URL with user_role and department_name parameters
    const userRole = sessionStorage.getItem('access_role') || '';
    const userDepartment = sessionStorage.getItem('user_department') || '';
    
    // Determine which department to use
    // For admin: use the selected department filter if set
    // For manager: always use their own department
    let department = null;
    if (accessRole === 'admin') {
      // If admin has selected a specific department, use that
      if (selectedDepartment) {
        department = selectedDepartment;
      }
      // If no department selected, department will be null and backend returns all
    } else {
      // Manager uses their own department
      department = userDepartment;
    }
    
    let url = `/bulk-upload/template?user_role=${encodeURIComponent(userRole)}`;
    if (department) {
      url += `&department_name=${encodeURIComponent(department)}`;
    }
    
    const response = await apiService.fetchData(url, {
      responseType: 'blob'
    });
    
    const blob = new Blob([response], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    
    // Set filename based on role and department selection
    let filename;
    if (accessRole === 'admin' && !selectedDepartment) {
      // Admin without department filter - all departments
      filename = 'FrameworkOverview_template_all_departments.xlsx';
    } else {
      // Admin with department filter or Manager
      const deptName = department || userDepartment;
      filename = `FrameworkOverview_template_${deptName.replace(/ /g, '_')}.xlsx`;
    }
    link.download = filename;
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
    
    setSnackbar({
      message: 'Template downloaded successfully!',
      type: 'success',
      isOpen: true
    });
  } catch (error) {
    console.error('Failed to download template:', error);
    setSnackbar({
      message: 'Failed to download template',
      type: 'error',
      isOpen: true
    });
  }
};

const handleBulkUpload = async (event) => {
  const file = event.target.files[0];
  if (!file) return;
  
  const formData = new FormData();
  formData.append('file', file);
  
  // Add context based on role
  if (accessRole === 'admin' && selectedDepartment) {
    formData.append('department_name', selectedDepartment);
  } else if (accessRole === 'manager') {
    const department = sessionStorage.getItem('user_department');
    if (department) {
      formData.append('department_name', department);
    }
  }
  
  try {
    // Show uploading message with long duration (will be manually closed on response)
    setSnackbar({
      message: 'Uploading file... Please wait.',
      type: 'info',
      isOpen: true,
      duration: 300000  // 5 minutes - will be closed manually when API responds
    });
    
    // Use postBulkUpload which returns error data instead of throwing
    const response = await apiService.postBulkUpload('/bulk-upload/capability-categories', formData);
    
    // Close the snackbar before showing popup
    setSnackbar(prev => ({ ...prev, isOpen: false }));
    
    // Show detailed popup for success, partial_success, and error (response includes status field)
    if (response && (response.status === 'success' || response.status === 'partial_success' || response.status === 'error')) {
      setBulkUploadResult(response);
      setBulkUploadPopupOpen(true);
      
      // Refresh data if any roles were successfully uploaded
      if (response.status === 'success' || response.status === 'partial_success') {
        if (accessRole === 'admin') {
          fetchAdminDepartments();
        } else {
          fetchCategories();
        }
      }
    } else {
      // Unexpected response format
      setSnackbar({
        message: 'Upload completed but response format unexpected',
        type: 'warning',
        isOpen: true
      });
    }
  } catch (error) {
    console.error('Bulk upload failed:', error);
    // Close the snackbar
    setSnackbar(prev => ({ ...prev, isOpen: false }));
    
    // For network errors or other unexpected errors, show snackbar
    setSnackbar({
      message: 'Upload failed: ' + (error.message || 'Unknown error'),
      type: 'error',
      isOpen: true
    });
  } finally {
    // Reset file input
    event.target.value = '';
  }
};

// const handleSaveCategory = async (categoryData) => {
//   setIsSavingCategory(true); 
//   const currentTotalWeightage = categories.reduce((sum, cat) => 
//   sum + parseInt(cat.percentage || 0), 0
// );

// const newCategoryWeightage = parseInt(categoryData.weightage || 0);
// const updatedTotal = editingCategory 
//   ? currentTotalWeightage - parseInt(editingCategory.percentage) + newCategoryWeightage
//   : currentTotalWeightage + newCategoryWeightage;

// if (updatedTotal > 100) {
//   setSnackbar({
//     message: `Cannot save: Total weightage for this role in this department would exceed 100% (Current: ${currentTotalWeightage}%, New Total: ${updatedTotal}%)`,
//     type: 'error',
//     isOpen: true
//   });
//   return;
// }

// if (updatedTotal < 100 && !editingCategory) {
//   setSnackbar({
//     message: `Warning: Total weightage will be ${updatedTotal}%. It should eventually reach 100%.`,
//     type: 'warning',
//     isOpen: true
//   });
// }

//   try {
//     const department = sessionStorage.getItem('user_department') || 'Salesforce';
//     const roleName = sessionStorage.getItem('user_role') || 'Developer';

//     const payload = {
//       CategoryName: categoryData.name.trim(),
//       Description: categoryData.description.trim(),
//       IsActive: 1,
//       Weightage: parseInt(categoryData.percentage),
//       ...(categoryData.id ? {} : {
//         user_department_name: department,
//         user_role_name: roleName
//       })
//     };

//     if (categoryData.id) {
//       await apiService.putData(`/capability-categories/${categoryData.id}`, payload);
//     } else {
//       await apiService.postData('/capability-categories', payload);
//     }

//     await fetchCategories();  // Refresh list
//     setIsCategoryModalOpen(false);
//     setEditingCategory(null);
//   } catch (err) {
//     console.error('Save failed:', err);
//     alert('Failed to save category.');
//   } finally {
//     setIsSavingCategory(false);  
//     setIsCategoryModalOpen(false);
//     setEditingCategory(null);
//     fetchCategories();
//   }
// };

const handleSaveCategory = async (categoryData) => {
  setIsSavingCategory(true);

  const currentTotalWeightage = categories.reduce(
    (sum, cat) => sum + parseInt(cat.percentage || 0),
    0
  );

  const newCategoryWeightage = parseInt(categoryData.percentage || 0);
  const updatedTotal = editingCategory
    ? currentTotalWeightage -
      parseInt(editingCategory.percentage || 0) +
      newCategoryWeightage
    : currentTotalWeightage + newCategoryWeightage;

  if (updatedTotal > 100) {
    setSnackbar({
      message: `Cannot save: Total weightage would exceed 100% (Current: ${currentTotalWeightage}%, New Total: ${updatedTotal}%)`,
      type: "error",
      isOpen: true,
    });
    setIsSavingCategory(false);
    return;
  }

  try {
    // 🎉 Correct department & role
    const department =
      selectedDepartment ||
      sessionStorage.getItem("user_department");

    const roleName =
      categoryData.role_name ||          // role from modal
      selectedRoleForAdmin ||            // admin selected role
      selectedRoleForManager ||          // manager selected role
      sessionStorage.getItem("user_role");

    console.log("Saving Category For: ", { department, roleName });

    const payload = {
      CategoryName: categoryData.name.trim(),
      Description: categoryData.description.trim(),
      IsActive: 1,
      Weightage: parseInt(categoryData.percentage),
      ...(categoryData.id
        ? {}
        : {
            user_department_name: department,
            user_role_name: roleName,   
          })
    };

    if (categoryData.id) {
      await apiService.putData(`/capability-categories/${categoryData.id}`, payload);
    } else {
      await apiService.postData("/capability-categories", payload);
    }

    await fetchCategories();

    setSnackbar({
      message: editingCategory ? "Category updated successfully!" : "New category added successfully!",
      type: "success",
      isOpen: true,
    });

    setIsCategoryModalOpen(false);
    setEditingCategory(null);

  } catch (err) {
    console.error("Save failed:", err);
    let errorMessage = "Failed to save category.";
    
    if (err.response && err.response.status === 409) {
      errorMessage = err.response.data?.message || err.response.data || "Category already exists.";
    } else {
      errorMessage = err.message || "Failed to save category.";
    }
    
    setSnackbar({
      message: errorMessage,
      type: "error",
      isOpen: true,
    });
  } finally {
    setIsSavingCategory(false);
  }
};



const handleDeleteCategory = async (id, name) => {
  setDeleteConfirm({ id, name }); 
};

const confirmDelete = async () => {
  if (!deleteConfirm) return;

  try {
    await apiService.deleteData(`/capability-categories/${deleteConfirm.id}`);
    fetchCategories(); // Refresh list
    setDeleteConfirm(null); // Close popup
  } catch (err) {
    console.error('Delete failed:', err);
    alert('Failed to delete category.');
    setDeleteConfirm(null);
  }
};

const cancelDelete = () => {
  setDeleteConfirm(null);
};



  // Logout handler
  const handleLogout = () => {
    console.log('🚪 Logging out...');
    sessionStorage.clear();
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    window.location.href = config.logoutUrl;
  };

  const handleCardClick = (cardTitle) => {
    if (cardTitle === 'Take Assessment') {
      // Check access_role: managers go to /employees, users go to /takeassessment
      const normalizedRole = (accessRole || 'user').toString().toLowerCase().trim();
      if (normalizedRole === 'manager') {
        navigate('/employees');
      } else {
        navigate('/takeassessment');
      }
    } else if (cardTitle === 'Manage Assessments') {
      navigate('/manageassessments');
    } else if (cardTitle === 'Dashboard') {
      navigate('/dashboard');
    } else if (cardTitle === 'Calibration Review') {
      navigate('/calibrationreview');
    }
    else if (cardTitle === 'Assessment Cycles') {
    navigate('/assessment-cycles'); 
  }
  };

    const filteredCards = useMemo(() => {
    if (isLoadingRole) {
      console.log('⏳ Still loading role, showing empty array');
      return [];
    }

    // All available cards
    const allCards = ['Take Assessment', 'Manage Assessments', 'Dashboard', 'Calibration Review'];
    const userCards = ['Take Assessment', 'Calibration Review'];
    const adminCards = ['Manage Assessments', 'Dashboard', 'Calibration Review','Assessment Cycles'];

    const normalizedRole = (accessRole || 'user').toString().toLowerCase().trim();
    console.log('🔍 Filtering cards for role:', normalizedRole);

    let filtered = [];

    if (normalizedRole === 'admin') {
      // ✅ Admins see everything except "Take Assessment"
      filtered = headerCards.filter(card => adminCards.includes(card.title));
      console.log('✅ Admin access - showing cards:', filtered.map(c => c.title));
    } else if (normalizedRole === 'manager') {
      // ✅ Managers see all cards
      filtered = headerCards.filter(card => allCards.includes(card.title));
      console.log('✅ Manager access - showing all cards');
    } else {
      // 👤 Users see limited cards
      filtered = headerCards.filter(card => userCards.includes(card.title));
      console.log('👤 User access - showing limited cards');
    }

    return filtered;
  }, [accessRole, isLoadingRole]);

  const containerClass = filteredCards.length === 2 ? 'user-cards' : 'home-cards-grid';


  return (
    <div className="home-container">
      {/* Global Loader */}
      {isGlobalLoading && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
          flexDirection: 'column',
          gap: '20px'
        }}>
          <div className="spinner" style={{
            width: '50px',
            height: '50px',
            border: '4px solid #f3f4f6',
            borderTop: '4px solid #4f46e5',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }}></div>
          <p style={{ color: '#6b7280', fontSize: '16px', margin: 0 }}>Setting up your workspace...</p>
        </div>
      )}
      
      {/* Header Section */}
      <header className="new-fixed-header">
  <div className="new-header-content">
    <div className="new-header-left">
      <img 
        src="/crlogo.png" 
        alt="CR Logo" 
        className="header-logo"
        onClick={() => navigate('/Home')}
      />
      <span className="capability-index-text">Capability Index</span>
    </div>

    <div className="new-header-right">


      <div className="new-divider"></div>

      {/* Profile */}
       <div ref={profileDropdownRef}>
      <div className="new-profile-btn" onClick={(e) => {
    e.stopPropagation();           
    setShowProfileDropdown(prev => !prev);
  }}>
       <div className="new-profile-avatar">
  {profileImage ? (
    <img
      src={profileImage}
      alt="Profile"
      className="new-profile-avatar-img"
    />
  ) : (
    (sessionStorage.getItem('user_name'))
      .split(' ')
      .map(n => n[0])
      .join('')
      .toUpperCase()
      .slice(0, 2)
  )}
</div>


        <div className="new-profile-info">
          <div className="new-profile-name">
            {sessionStorage.getItem('user_name')}
          </div>
          <div className="new-profile-role">
            {sessionStorage.getItem('access_role') === 'admin' ? 'Administrator' : 
             sessionStorage.getItem('access_role') === 'manager' ? 'Manager' : 'User'}
          </div>
        </div>
        <svg className="new-dropdown-arrow" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"/>
        </svg>
      </div>
      {showProfileDropdown && (
      <div className="profile-dropdown-menu">
        <div className="dropdown-user-header">
          <div className="dropdown-large-avatar">
            {profileImage ? (
              <img
                src={profileImage}
                alt="Profile"
                className="dropdown-avatar-img"
                style={{
                  width: '100%',
                  height: '100%',
                  borderRadius: '50%',
                  objectFit: 'cover'
                }}
              />
            ) : (
              sessionStorage.getItem('user_name')?.split(' ').map(n => n[0]).join('').toUpperCase().slice(0,2) || 'JD'
            )}
          </div>
          <div className="dropdown-user-info">
            <div className="dropdown-user-name">
              {sessionStorage.getItem('user_name')}
            </div>
            <div className="dropdown-user-email">
              {sessionStorage.getItem('user_emailId')}
            </div>
            <span className="dropdown-role-badge">
              {sessionStorage.getItem('access_role') === 'admin' ? 'Administrator' : 
               sessionStorage.getItem('access_role') === 'manager' ? 'Manager' : 'User'}
            </span>
          </div>
        </div>

       <div className="dropdown-menu-list">
  {/* My Profile */}
  <div className="dropdown-menu-item" onClick={() => {
    setShowProfileDropdown(false);  
    setShowProfileModal(true);        
  }}>
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="7" r="4"/>
      <path d="M20 21v-2a8 8 0 0 0-16 0v2"/>
    </svg>
    <span>My Profile</span>
  </div>
{['admin', 'manager'].includes(sessionStorage.getItem('access_role')?.toLowerCase()) && (
        <div 
          className="dropdown-menu-item" 
          onClick={() => {
            setShowProfileDropdown(false);
            navigate('/roles');
          }}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
            <circle cx="8.5" cy="7" r="4"/>
            <path d="M20 8v5"/>
            <path d="M23 11l-3-3-3 3"/>
          </svg>
          <span>Roles Management</span>
        </div>
      )}
      
      {['admin', 'manager'].includes(sessionStorage.getItem('access_role')?.toLowerCase()) && (
        <div 
          className="dropdown-menu-item" 
          onClick={() => {
            setShowProfileDropdown(false);
            navigate('/department-management');
          }}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
          </svg>
          <span>Manage Departments</span>
        </div>
      )}
      
  {/* Account Settings */}
    {/* Role Switch — Only show if user has multiple roles */}
  {hasMultipleRoles() && (
    <div className="dropdown-menu-item" onClick={() => {
      setShowProfileDropdown(false);
      setIsRoleSwitchOpen(true);
    }}>
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M19 9l-7 7-7-7"/>
        <circle cx="12" cy="12" r="10"/>
        <path d="M8 12a4 4 0 1 0 8 0a4 4 0 1 0-8 0z"/>
      </svg>
      <span>Role Switch</span>
    </div>
  )}

  <div className="dropdown-menu-item" onClick={() => setIsDepartmentSwitchOpen(true)}>
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
    </svg>
    <span>Department Switch</span>
  </div>

  <div className="dropdown-divider"></div>

  {/* Logout */}
  <div className="dropdown-menu-item logout-item" onClick={handleLogout}>
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M17 16l4-4m0 0l-4-4m4 4H7"/>
      <path d="M13 19H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h7"/>
    </svg>
    <span>Logout</span>
  </div>
</div>
      </div>
    )}
      </div>
    </div>
  </div>
      </header>
      <div className="header-section">
        <div className="header-top">
          <div className="header-content">
            <h1 className="main-title">Capability Index</h1>
            <p className="main-subtitle">
              A structured, objective framework to assess skills, identify growth areas, and calibrate team performance against defined role expectations.
            </p>
          </div>
          {/* <div className="logout-section">
            <button 
              onClick={handleLogout}
              className="logout-button"
              title="Logout"
            >
              <span role="img" aria-label="logout">🚪</span>
              Logout
            </button>
          </div> */}
        </div>
        
        <div className={`home-cards-grid ${filteredCards.length === 2 ? 'user-cards' : ''}`}>
  {filteredCards.map((card, index) => (
    <div
      key={index}
      className={`header-card clickable-card`}
      onClick={() => handleCardClick(card.title)}
      style={{ '--card-color': card.iconColor }}
    >
      <div className="card-header-row">
  <div className="card-icon" style={{ backgroundColor: card.iconColor }}>
    {card.icon}
  </div>
  <h3 className="card-title">{card.title}</h3>
</div>
<p className="card-description">{card.description}</p>
    </div>
  ))}
</div>
      </div>

      {/* Framework Overview Section - Updated */}
<div className="framework-section">
  {/* Header with Add Button - ONLY for Manager & Admin */}
  <div className="framework-header">
    <h2 className="framework-section-title">Framework Overview</h2>

  {(accessRole === 'manager' || accessRole === 'admin') && (
  <div className="manager-category-controls">

    {/* ==================== ADMIN: Download Template & Bulk Upload ==================== */}
    {accessRole === 'admin' && (
      <>
        {/* Commented out Download Template and Bulk Upload buttons
        <button
          onClick={handleDownloadTemplate}
          className="btn-download-template"
          style={{ marginRight: '10px' }}
        >
          📥 Download Template
        </button>
        <button
          onClick={() => document.getElementById('admin-bulk-upload').click()}
          className="btn-bulk-upload"
          style={{ marginRight: '15px' }}
        >
          📤 Bulk Upload
        </button>
        <input
          id="admin-bulk-upload"
          type="file"
          accept=".xlsx,.xls"
          style={{ display: 'none' }}
          onChange={handleBulkUpload}
        />
        */}
        
        <div className="role-dropdown-with-search">
          <label style={{ fontSize: '14px', fontWeight: '500', color: '#374151' }}>Select Department:</label>
          <div className="dropdown-wrapper">
            <button
              className="dropdown-selected"
              style={{ fontSize: '14px', fontFamily: 'inherit' }}
              onClick={(e) => {
    e.stopPropagation();

    const wrapper = e.currentTarget.closest('.dropdown-wrapper');
    const menu = wrapper.querySelector('.dropdown-menu');

    // Close other open dropdowns
    document.querySelectorAll('.dropdown-menu.open').forEach(d => {
      if (d !== menu) d.classList.remove('open');
    });

    menu.classList.toggle('open');
  }}
            >
              <span>{selectedDepartment || 'Select Department'}</span>
              <svg className="dropdown-arrow" viewBox="0 0 24 24">
                <path d="M7 10l5 5 5-5z" />
              </svg>
            </button>

            <div className="dropdown-menu dept-dropdown-menu">
              <div className="dropdown-search">
                <input
                  type="text"
                  placeholder="Search departments..."
                  value={deptSearchTerm}
                  onChange={(e) => setDeptSearchTerm(e.target.value)}
                  onClick={(e) => e.stopPropagation()}
                  style={{ fontSize: '14px', fontFamily: 'inherit' }}
                  autoFocus
                />
              </div>
              <div className="dropdown-items">
                {availableDepartments
                  .filter(dept => dept.name.toLowerCase().includes(deptSearchTerm.toLowerCase()))
                  .map(dept => (
                    <div
                      key={dept.id}
                      className={`dropdown-item ${dept.name === selectedDepartment ? 'selected' : ''}`}
                      style={{ fontSize: '14px', fontFamily: 'inherit' }}
                      onClick={() => {
                        setSelectedDepartment(dept.name);
                        setSelectedRoleFamily(null);
                        setSelectedRoleForAdmin(null);
                        setDeptSearchTerm('');
                        document.querySelector('.dept-dropdown-menu')?.classList.remove('open');
                      }}
                    >
                      {dept.name}
                    </div>
                  ))}
                {availableDepartments.filter(d => d.name.toLowerCase().includes(deptSearchTerm.toLowerCase())).length === 0 && (
                  <div className="dropdown-no-results" style={{ fontSize: '14px' }}>No departments found</div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Role Family Dropdown for Admin */}
        {selectedDepartment && availableRoleFamilies.length > 0 && (
          <div className="role-dropdown-with-search">
            <label style={{ fontSize: '14px', fontWeight: '500', color: '#374151' }}>Select Role Family:</label>
            <div className="dropdown-wrapper">
              <button
                className="dropdown-selected"
                style={{ fontSize: '14px', fontFamily: 'inherit' }}
                onClick={(e) => {
                  e.stopPropagation();
                  const wrapper = e.currentTarget.closest('.dropdown-wrapper');
                  const menu = wrapper.querySelector('.dropdown-menu');
                  document.querySelectorAll('.dropdown-menu.open').forEach(d => {
                    if (d !== menu) d.classList.remove('open');
                  });
                  menu.classList.toggle('open');
                }}
              >
                <span>{selectedRoleFamily || 'All Role Families'}</span>
                <svg className="dropdown-arrow" viewBox="0 0 24 24">
                  <path d="M7 10l5 5 5-5z" />
                </svg>
              </button>

              <div className="dropdown-menu admin-role-family-dropdown-menu">
                <div className="dropdown-search">
                  <input
                    type="text"
                    placeholder="Search role families..."
                    value={roleFamilySearchTerm}
                    onChange={(e) => setRoleFamilySearchTerm(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                    style={{ fontSize: '14px', fontFamily: 'inherit' }}
                    autoFocus
                  />
                </div>
                <div className="dropdown-items">
                  <div
                    className={`dropdown-item ${!selectedRoleFamily ? 'selected' : ''}`}
                    style={{ fontSize: '14px', fontFamily: 'inherit' }}
                    onClick={() => {
                      setSelectedRoleFamily(null);
                      setSelectedRoleForAdmin(null);
                      setRoleFamilySearchTerm('');
                      document.querySelector('.admin-role-family-dropdown-menu')?.classList.remove('open');
                    }}
                  >
                    All Role Families
                  </div>
                  {availableRoleFamilies
                    .filter(rf => rf.toLowerCase().includes(roleFamilySearchTerm.toLowerCase()))
                    .map(rf => (
                      <div
                        key={rf}
                        className={`dropdown-item ${rf === selectedRoleFamily ? 'selected' : ''}`}
                        style={{ fontSize: '14px', fontFamily: 'inherit' }}
                        onClick={() => {
                          setSelectedRoleFamily(rf);
                          setSelectedRoleForAdmin(null);
                          setRoleFamilySearchTerm('');
                          document.querySelector('.admin-role-family-dropdown-menu')?.classList.remove('open');
                        }}
                      >
                        {rf}
                      </div>
                    ))}
                  {availableRoleFamilies.filter(rf => rf.toLowerCase().includes(roleFamilySearchTerm.toLowerCase())).length === 0 && (
                    <div className="dropdown-no-results" style={{ fontSize: '14px' }}>No role families found</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {selectedDepartment && getFilteredRolesForAdmin().length > 0 && (
          <div className="role-dropdown-with-search">
            <label style={{ fontSize: '14px', fontWeight: '500', color: '#374151' }}>Select Role:</label>
            <div className="dropdown-wrapper">
              <button
                className="dropdown-selected"
                style={{ fontSize: '14px', fontFamily: 'inherit' }}
                onClick={(e) => {
                  e.stopPropagation();
                  const wrapper = e.currentTarget.closest('.dropdown-wrapper');
                  const menu = wrapper.querySelector('.dropdown-menu');
                  document.querySelectorAll('.dropdown-menu.open').forEach(d => {
                    if (d !== menu) d.classList.remove('open');
                  });
                  menu.classList.toggle('open');
                }}
              >
                <span>{selectedRoleForAdmin || 'Select Role'}</span>
                <svg className="dropdown-arrow" viewBox="0 0 24 24">
                  <path d="M7 10l5 5 5-5z" />
                </svg>
              </button>

              <div className="dropdown-menu admin-role-dropdown-menu">
                <div className="dropdown-search">
                  <input
                    type="text"
                    placeholder="Search roles..."
                    value={roleSearchTerm}
                    onChange={(e) => setRoleSearchTerm(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                    style={{ fontSize: '14px', fontFamily: 'inherit' }}
                    autoFocus
                  />
                </div>
                <div className="dropdown-items">
                  {getFilteredRolesForAdmin()
                    .filter(role => role.RoleName.toLowerCase().includes(roleSearchTerm.toLowerCase()))
                    .map(role => (
                      <div
                        key={role.RoleID}
                        className={`dropdown-item ${role.RoleName === selectedRoleForAdmin ? 'selected' : ''}`}
                        style={{ fontSize: '14px', fontFamily: 'inherit' }}
                        onClick={() => {
                          setSelectedRoleForAdmin(role.RoleName);
                          setRoleSearchTerm('');
                          document.querySelector('.admin-role-dropdown-menu')?.classList.remove('open');
                        }}
                      >
                        {role.RoleName} ({role.resource_count || 0})
                      </div>
                    ))}
                  {getFilteredRolesForAdmin().filter(r => r.RoleName.toLowerCase().includes(roleSearchTerm.toLowerCase())).length === 0 && (
                    <div className="dropdown-no-results" style={{ fontSize: '14px' }}>No roles found</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    )}

    {/* ==================== MANAGER: Download Template & Bulk Upload ==================== */}
    {accessRole === 'manager' && (
      <>
        {/* Commented out Download Template and Bulk Upload buttons
        <button
          onClick={handleDownloadTemplate}
          className="btn-download-template"
          style={{ marginRight: '10px' }}
        >
          📥 Download Template
        </button>
        <button
          onClick={() => document.getElementById('manager-bulk-upload').click()}
          className="btn-bulk-upload"
          style={{ marginRight: '15px' }}
        >
          📤 Bulk Upload
        </button>
        <input
          id="manager-bulk-upload"
          type="file"
          accept=".xlsx,.xls"
          style={{ display: 'none' }}
          onChange={handleBulkUpload}
        />
        */}
      </>
    )}
    
    {/* Role Family Dropdown for Manager */}
    {accessRole === 'manager' && availableRoleFamiliesForManager.length > 0 && (
      <div className="role-dropdown-with-search">
        <label style={{ fontSize: '14px', fontWeight: '500', color: '#374151' }}>Select Role Family:</label>
        <div className="dropdown-wrapper">
          <button
            className="dropdown-selected"
            style={{ fontSize: '14px', fontFamily: 'inherit' }}
            onClick={(e) => {
              e.stopPropagation();
              const wrapper = e.currentTarget.closest('.dropdown-wrapper');
              const menu = wrapper.querySelector('.dropdown-menu');
              document.querySelectorAll('.dropdown-menu.open').forEach(d => {
                if (d !== menu) d.classList.remove('open');
              });
              menu.classList.toggle('open');
            }}
          >
            <span>{selectedRoleFamilyForManager || 'All Role Families'}</span>
            <svg className="dropdown-arrow" viewBox="0 0 24 24">
              <path d="M7 10l5 5 5-5z" />
            </svg>
          </button>

          <div className="dropdown-menu manager-role-family-dropdown-menu">
            <div className="dropdown-search">
              <input
                type="text"
                placeholder="Search role families..."
                value={roleFamilySearchTermManager}
                onChange={(e) => setRoleFamilySearchTermManager(e.target.value)}
                onClick={(e) => e.stopPropagation()}
                style={{ fontSize: '14px', fontFamily: 'inherit' }}
                autoFocus
              />
            </div>
            <div className="dropdown-items">
              <div
                className={`dropdown-item ${!selectedRoleFamilyForManager ? 'selected' : ''}`}
                style={{ fontSize: '14px', fontFamily: 'inherit' }}
                onClick={() => {
                  setSelectedRoleFamilyForManager(null);
                  setSelectedRoleForManager(null);
                  setRoleFamilySearchTermManager('');
                  document.querySelector('.manager-role-family-dropdown-menu')?.classList.remove('open');
                }}
              >
                All Role Families
              </div>
              {availableRoleFamiliesForManager
                .filter(rf => rf.toLowerCase().includes(roleFamilySearchTermManager.toLowerCase()))
                .map(rf => (
                  <div
                    key={rf}
                    className={`dropdown-item ${rf === selectedRoleFamilyForManager ? 'selected' : ''}`}
                    style={{ fontSize: '14px', fontFamily: 'inherit' }}
                    onClick={() => {
                      setSelectedRoleFamilyForManager(rf);
                      setSelectedRoleForManager(null);
                      setRoleFamilySearchTermManager('');
                      document.querySelector('.manager-role-family-dropdown-menu')?.classList.remove('open');
                    }}
                  >
                    {rf}
                  </div>
                ))}
              {availableRoleFamiliesForManager.filter(rf => rf.toLowerCase().includes(roleFamilySearchTermManager.toLowerCase())).length === 0 && (
                <div className="dropdown-no-results" style={{ fontSize: '14px' }}>No role families found</div>
              )}
            </div>
          </div>
        </div>
      </div>
    )}

    {accessRole === 'manager' && getFilteredRolesForManager().length > 0 && (
      <div className="role-dropdown-with-search">
        <label style={{ fontSize: '14px', fontWeight: '500', color: '#374151' }}>View Categories For:</label>
        <div className="dropdown-wrapper">
          <button
            className="dropdown-selected"
            style={{ fontSize: '14px', fontFamily: 'inherit' }}
            onClick={(e) => {
              e.stopPropagation();
              const wrapper = e.currentTarget.closest('.dropdown-wrapper');
              const menu = wrapper.querySelector('.dropdown-menu');
              document.querySelectorAll('.dropdown-menu.open').forEach(d => {
                if (d !== menu) d.classList.remove('open');
              });
              menu.classList.toggle('open');
            }}
          >
            <span>{selectedRoleForManager || 'Select Role'}</span>
            <svg className="dropdown-arrow" viewBox="0 0 24 24">
              <path d="M7 10l5 5 5-5z" />
            </svg>
          </button>

          <div className="dropdown-menu manager-role-dropdown-menu">
            <div className="dropdown-search">
              <input
                type="text"
                placeholder="Search roles..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onClick={(e) => e.stopPropagation()}
                style={{ fontSize: '14px', fontFamily: 'inherit' }}
                autoFocus
              />
            </div>
            <div className="dropdown-items">
              {getFilteredRolesForManager()
                .filter(role => role.roleName.toLowerCase().includes(searchTerm.toLowerCase()))
                .map(role => (
                  <div
                    key={role.roleId}
                    className={`dropdown-item ${role.roleName === selectedRoleForManager ? 'selected' : ''}`}
                    style={{ fontSize: '14px', fontFamily: 'inherit' }}
                    onClick={() => {
                      setSelectedRoleForManager(role.roleName);
                      setSearchTerm('');
                      document.querySelector('.manager-role-dropdown-menu')?.classList.remove('open');
                    }}
                  >
                    {role.roleName} ({role.resourceCount || 0})
                  </div>
                ))}
              {getFilteredRolesForManager().filter(r => r.roleName.toLowerCase().includes(searchTerm.toLowerCase())).length === 0 && (
                <div className="dropdown-no-results" style={{ fontSize: '14px' }}>No roles found</div>
              )}
            </div>
          </div>
        </div>
      </div>
    )}

    {/* ==================== Add Category Button (Both) ==================== */}
    <button
      onClick={() => {
        setEditingCategory(null);
        setIsCategoryModalOpen(true);
      }}
      className="btn-add-category"
    >
      + Add Category
    </button>

  </div>
)}
  </div>

  <p className="framework-section-subtitle">
    Our Capability Index framework measures and benchmarks technical, analytical, and behavioral capabilities against role expectations.
  </p>

  <div className="capability-categories-container">
    <div className="capability-header">
      <h3 className="capability-title">Capability Categories</h3>
      <p className="capability-subtitle">
        Key dimensions with weighted scoring (Total: {categories.reduce((sum, c) => sum + parseInt(c.percentage), 0)}%)
      </p>
    </div>

   {/* <div className="capabilities-grid">
  {categories.length === 0 ? (
    <div className="no-categories">
      No capability categories defined for this role.
    </div>
  ) : (
    categories.map((capability) => (
      <div key={capability.id} className="capability-card">

  <div className="capability-header-row">
    <h4 className="capability-name">{capability.name}</h4>

    <div className="capability-weightage-actions">
      <span className="capability-percentage">{capability.percentage}</span>

      
      {(accessRole === 'manager' || accessRole === 'admin') && (
        <div className="card-actions">
          <button
            className="action-btn edit"
            data-tooltip="Edit"
            onClick={() => {
              setEditingCategory(capability);
              setIsCategoryModalOpen(true);
            }}
          >
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
            </svg>
          </button>

         <button
  className="action-btn delete"
  data-tooltip="Delete"
  onClick={() => handleDeleteCategory(capability.id, capability.name)} // Pass name
>
  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
  </svg>
</button>
        </div>
      )}
    </div>
  </div>

  <p className="capability-desc">{capability.description}</p>
</div>
    ))
  )}
</div> */}
<div className="capabilities-grid">
  {isLoadingCategories ? (
    /* Spinner while loading */
    <div className="categories-loader">
      <div className="spinner"></div>
      <p>Loading capability categories…</p>
    </div>
  ) : categories.length === 0 ? (
    /* Existing "no data" message */
    <div className="no-categories">
      No capability categories defined for this role.
    </div>
  ) : (
    /* Existing categories list – 100% unchanged */
    categories.map((capability) => (
      <div key={capability.id} className="capability-card">
        <div className="capability-header-row" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'nowrap', minWidth: '100%' }}>
          <h4 className="capability-name" style={{ flex: '1', minWidth: '0', marginRight: '12px' }}>{capability.name}</h4>

          <div className="capability-weightage-actions" style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
            <span className="capability-percentage">{capability.percentage}</span>

            {/* Edit & Delete Icons – Only for Manager/Admin */}
            {(accessRole === 'manager' || accessRole === 'admin') && (
              <div className="card-actions">
                <button
                  className="action-btn edit"
                  data-tooltip="Edit"
                  onClick={() => {
                    setEditingCategory(capability);
                    setIsCategoryModalOpen(true);
                  }}
                >
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                    />
                  </svg>
                </button>

                <button
                  className="action-btn delete"
                  data-tooltip="Delete"
                  onClick={() => handleDeleteCategory(capability.id, capability.name)}
                >
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                    />
                  </svg>
                </button>
              </div>
            )}
          </div>
        </div>

        <p className="capability-desc">{capability.description}</p>
      </div>
    ))
  )}
</div>
  </div>
</div>

{/* Modals */}
<CapabilityCategoryModal
  isOpen={isCategoryModalOpen}
 onClose={() => !isSavingCategory && setIsCategoryModalOpen(false)}
  category={editingCategory}
  onSave={handleSaveCategory}
  isSaving={isSavingCategory}
  selectedRole={selectedRoleForManager}
  availableRoles={availableRoles}
  selectedDepartment={selectedDepartment}     
  accessRole={accessRole}
/>
{/* Delete Confirmation Popup */}
{deleteConfirm && (
  <div className="modal-overlay" style={{ zIndex: 1000 }}>
    <div className="delete-confirm-modal">
      <div className="delete-confirm-icon">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2">
          <circle cx="12" cy="12" r="10" />
          <path d="M15 9l-6 6M9 9l6 6" />
        </svg>
      </div>
      <h3>Delete Category?</h3>
      <p>
        Are you sure you want to delete <strong>"{deleteConfirm.name}"</strong>?<br />
        This action cannot be undone.
      </p>
      <div className="delete-confirm-buttons">
        <button onClick={cancelDelete} className="btn-cancel">
          Cancel
        </button>
        <button onClick={confirmDelete} className="btn-delete">
          Yes, Delete
        </button>
      </div>
    </div>
  </div>
)}
    <div className="roles-section">
  <div className="roles-header">
    <h2 className="role-section-title" style={{ textAlign: "center" }}>
      Role-Based Expectations
    </h2>
    <p className="role-section-subtitle">
      Expected CI score ranges for different role levels.
    </p>
  </div>

  <div className="roles-list">
    {isLoadingRoles ? (
      <div className="categories-loader">
        <div className="spinner"></div>
        <p>Loading Role-based expectations...</p>
      </div>
    ) : roleExpectations.length === 0 ? (
      <div className="no-categories" style={{ gridColumn: "1 / -1", textAlign: "center" }}>
        No role expectations defined for this department.
      </div>
    ) : (
      roleExpectations
        .filter(role => {
          if (accessRole === 'admin') {
            return !selectedRoleForAdmin || role.title === selectedRoleForAdmin;
          } else if (accessRole === 'manager') {
            return !selectedRoleForManager || role.title === selectedRoleForManager;
          } else {
            const userRole = sessionStorage.getItem('user_role');
            return !userRole || role.title === userRole;
          }
        })
        .map((role, index) => (
        <div key={index} className="role-card">
          <div className="role-content">
            <h3 className="role-title">{role.title}</h3>
            <p className="role-description">{role.description}</p>
          </div>
          <div className="role-meta">
            <div className="meta-group">
              <span className="meta-label">Experience</span>
              <span className="meta-value experience-box">{role.experience}</span>
            </div>
            <div className="meta-group">
              <span className="meta-label">Expected CI</span>
              <span className="meta-value ci-box">{role.expectedCI}</span>
            </div>
          </div>
        </div>
      ))
    )}
  </div>
</div>


      <div className="rubric-section">
  {/* Gradient Header */}
  <div className="rubric-header">
    <h2 className="role-section-title" style={{textAlign:"center"}}>Evaluation Rubric</h2>
    <p className="role-section-subtitle">Five-point scale for capability assessment.</p>
  </div>

  <div className="rubric-list">
    {rubric.map((item, index) => (
      <div key={index} className="rubric-item">
        <div 
          className="rubric-circle" 
          style={{ backgroundColor: item.color }}
        >
          {item.level}
        </div>
        <div className="rubric-content">
          <h3 className="rubric-name">{item.name}</h3>
          <p className="rubric-description">{item.description}</p>
        </div>
      </div>
    ))}
  </div>
</div>
<ProfileModal 
        isOpen={showProfileModal}
        onClose={() => setShowProfileModal(false)}
      />
      <RoleSwitchModal
  isOpen={isRoleSwitchOpen}
  onClose={() => setIsRoleSwitchOpen(false)}
  currentRole={accessRole}
  onRoleSwitch={(newRole) => {
    sessionStorage.setItem('access_role', newRole);
    window.location.reload(); 
  }}
/>
<DepartmentSwitchModal
  isOpen={isDepartmentSwitchOpen}
  onClose={() => setIsDepartmentSwitchOpen(false)}
  currentDepartment={userDepartment}
  onDepartmentSwitch={(newDept) => {
    sessionStorage.setItem('user_department', newDept);
    window.location.reload(); 
  }}
  availableDepartments={availableDepartments}
/>
      {snackbar.isOpen && (
  <Snackbar
    message={snackbar.message}
    type={snackbar.type}
    duration={snackbar.duration || 4000}
    onClose={() => setSnackbar({ ...snackbar, isOpen: false })}
  />
)}

{/* Bulk Upload Result Popup */}
<BulkUploadResultPopup
  open={bulkUploadPopupOpen}
  onClose={() => {
    setBulkUploadPopupOpen(false);
    setBulkUploadResult(null);
  }}
  data={bulkUploadResult}
  type="categories"
/>

      {/* Footer */}
      <div style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        textAlign: 'center',
        padding: '15px 0',
        borderTop: '1px solid #e5e7eb',
        backgroundColor: '#f9fafb',
        color: '#6b7280',
        fontSize: '14px',
        zIndex: 1000
      }}>
        © 2025 CriticalRiver. All rights reserved. Version {version}
      </div>
    </div>
  );
}

export default HomePage;
